import ValueWithLabelCard from 'src/components/primitives/ValueWithLabelCard/ValueWithLabelCard';
import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import { BigNum } from '@drift-labs/sdk';
import { DefinitionTooltipID } from 'src/components/Tooltip/DefinitionTooltip/definitionTooltipConfig';
import { cj } from 'src/utils/classNames';
import { ReactNode } from 'react';

interface Props {
	label: ReactNode;
	value: BigNum | undefined;
	loading?: boolean;
	skeletonPlaceholderClassName?: string;
	tooltipDefinitionId?: DefinitionTooltipID;
	displayType: 'percentage' | 'currency';
	valueClassName?: string;
	signDependentColor?: boolean;
	isAccountValueToHide?: boolean;
}

export default function PortfolioStatsCardItem({
	label,
	value,
	loading = false,
	skeletonPlaceholderClassName,
	tooltipDefinitionId,
	displayType,
	valueClassName,
	signDependentColor,
	isAccountValueToHide,
}: Props) {
	return (
		<ValueWithLabelCard.Item
			label={label}
			tooltipDefinitionId={tooltipDefinitionId}
		>
			<NumberDisplay
				value={value}
				type={displayType}
				decimals={2}
				className={valueClassName}
				loading={loading}
				skeletonClassName={cj('h-4 sm:h-6', skeletonPlaceholderClassName)}
				signDependentColor={signDependentColor}
				isAccountValueToHide={isAccountValueToHide}
				millify
			/>
		</ValueWithLabelCard.Item>
	);
}
